import { useTranslation } from 'react-i18next';
import {useState} from "react";
// Definición de un componente funcional
const DateRanges = ({  data, selectedUser }) => {
    const { t } = useTranslation();
    const totalWeek = data[selectedUser]?.measurement_count ?? 0
    const averagePerWeek_raw = data[selectedUser]?.average_per_week ?? 0
    const averagePerWeek = Number(averagePerWeek_raw).toFixed(1);

    return (
        <div className='h-full flex justify-content-center align-items-center'>
            <div className="pt-6 pb-5 px-4 sm:px-8 border rounded-md">
                <div className="text-8xl font-medium color-primary">{  totalWeek }</div>
                <div className="text-lg text-white uppercase font-bold mt-2">{ t('weekly-media') } { averagePerWeek }</div>
            </div>
        </div>
    );
}

export default DateRanges;
